import React from "react";
import { NavBar, Icon, List, Drawer } from "antd-mobile";
import { getMenuList, getLog } from "../../ajax/index.js";
import Drawerone from "./Drawerone.js";

import light from "../../assets/images/home/img_triangle_light.png";
import { changeMeta } from "../../common/Method.js";

import { createHashHistory } from "history";
const history = createHashHistory();

const Item = List.Item;
class MenuList extends React.Component {
  constructor(porps) {
    super(porps);
    this.state = {
      open: false, //抽屉隐藏状态
      open2: false,
      MenuListDatatwo: [], //二级分类数组
      MenuListDatathree: [], //三级分类数组
      indexid: 1,
      type: 1,
    };
  }
  componentDidMount() {
    //获取分类列表
    let id = this.props.match.params.id.split(",")[0];
    let language = this.props.match.params.id.split(",")[1];
    //发送埋点日记
    let currentUrl = window.location.href;
    let appId = "tsp.errorcode";
    let pointName = "/categorylist";
    getLog(currentUrl, appId, pointName);
    getMenuList(id, language).then((res) => {
      if (res.data.length > 0) {
        this.setState({
          MenuListDatatwo: res.data, //二级分类数组
        });

        let h = document.getElementById("my-list").offsetHeight;
        let bodyh = document.body.clientHeight;
        // console.log(h, 'height', bodyh)
        let height = bodyh - h;

        document.getElementById("hidenbtnWrap").style.height = height + "px";
      } else {
        this.props.history.push("/systemerror");
      }
    });

    // let jj = a.offsetHeight + a.offsetTop;
    // let bodyHeight = document.body.clientHeight;
    // let tableHeight = bodyHeight - t - 70 - num;
  }
  //抽屉展示隐藏
  onOpenChange = (id, listId, buId) => {
    // console.log(this.state.indexid, id, '888888888888888888888');
    if (this.state.indexid === id) {
      this.setState({
        open: !this.state.open,
      });
    } else {
      this.setState({
        open: true,
      });
    }
    this.setState({
      MenuListDatathree: [], //二级分类数组
      indexid: id,
    });

    //根据listId获取分类列表
    let language = this.props.match.params.id.split(",")[1];
    getMenuList(id, language).then((res) => {
      if (res.data.length < 1) {
        if (listId === "") {
          this.props.history.push("/systemerror");
        } else {
          console.log(id, language, buId, 99);
          this.props.history.push(
            "/errorCodeList/" + id + "," + language + "," + buId + "," + this.state.type
          );
        }
        // this.setState({
        //     open: false,
        // });
      } else {
        this.setState({
          MenuListDatathree: res.data,
        });
      }
      setTimeout(function () {
        [...document.getElementsByClassName("list-cont")].map((item) => {
          if (item) {
            let _p = item.parentNode;
            let _h = _p.clientHeight;
            if (_h > 51) {
              _p.className = "autoHeightli";
            }
          }
        });
      }, 100);
    });
  };
  //返回上一页
  back() {
    history.goBack();
  }
  //点击列表以外的地方收起抽屉
  Hidenbtn = () => {
    this.setState({
      open: false,
    });
  };
  changeType(e) {
    e.persist();
    let value = e.target.value;
    this.setState({
      type: value,
    });
  }
  render() {
    changeMeta(this.props.match.path);
    //根据id判断title
    let title = this.props.match.params.id.split(",")[0];
    let language = this.props.match.params.id.split(",")[1];
    switch (title) {
      case "40289a8168795712016879b353d2000a":
        title = "Residential Air Conditioner";
        break;
      case "8a90f926884278690188508f0c980078":
        title = "Residential Air Conditioner";
        break;
      case "40289a8168795712016879b40f20000c":
        title = "Laundry";
        break;
      case "40289a8168795712016879b4ae2f000e":
        title = "Small Domestic Appliances";
        break;
      case "40289a8168795712016879b5219b000f":
        title = "Commercial Air Conditioner";
        break;
      case "40289a8168795712016879b569f20010":
        title = "Refrigeration";
        break;
      case "40289a8168795712016879b5ee3b0011":
        title = "Kitchen & Water Heater";
        break;
      case "40289a8168795712016879b67bd80012":
        title = "Microwave & Cleaning Appliance";
        break;
      default:
        break;
    }
    return (
      <div className="transition-item detail-page">
        <div className="menu-style ">
          <NavBar
            mode="light"
            icon={<Icon type="left" />}
            onLeftClick={this.back}
          >
            {title}
          </NavBar>
          <div className="content">
            <select className="typeSelect" onChange={(e) => this.changeType(e)}>
            <option value="1">Fault Code</option>
              <option value="0">No Fault Code</option>
            </select>
            <List className="my-list" id="my-list">
              {/* 二级分类  autoHeightli*/}
              {this.state.MenuListDatatwo.map((i, key) => {
                var activeclass =
                  i.id === this.state.indexid && this.state.open
                    ? "active spanclass"
                    : "spanclass";
                var Draweractive =
                  i.id === this.state.indexid
                    ? "active my-drawer drawer-layer-1 "
                    : "my-drawer drawer-layer-1 none";

                return (
                  <div key={i.id}>
                    <Item
                      onClick={() => {
                        this.onOpenChange(i.id, i.listId, i.buId);
                      }}
                    >
                      {i.name}

                      <span className={activeclass}>
                        <img src={light} width="6" height="12" alt="light" />
                      </span>
                    </Item>
                    <Drawer
                      className={Draweractive}
                      style={{
                        minHeight: document.documentElement.clientHeight,
                      }}
                      enableDragHandle
                      contentStyle={{
                        color: "#A6A6A6",
                        textAlign: "center",
                        paddingTop: 60,
                      }}
                      sidebar={
                        <Drawerone
                          MenuListDatathree={this.state.MenuListDatathree}
                          open={this.state.open2}
                          onOpenChange={this.onOpenChange}
                          historys={this.props.history}
                          language={language}
                          buId={i.buId}
                          type={this.state.type}
                        />
                      }
                      open={this.state.open}
                      onOpenChange={this.onOpenChange}
                      position="right"
                      touch={false}
                    ></Drawer>
                  </div>
                );
              })}
            </List>
            <div
              className="hidenbtn"
              id="hidenbtnWrap"
              onClick={this.Hidenbtn}
            ></div>
          </div>
        </div>
      </div>
    );
  }
}
export default MenuList;



// WEBPACK FOOTER //
// ./src/pages/Home/MenuIndex.js